module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea.2d302b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/product/flea.jpg
// module id = rJtg
// module chunks = 0